import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-one-number',
    templateUrl: './one-number.component.html'
})
export class OneNumberComponent {
    @Input() reportType;
    @Input() value;
    @Input() loading;

    constructor(private router: Router) {}

    getDigitsClass(): any {
        if (!this.value) { return 'big-numbers'; }
        if (this.value < 10000) { return 'big-numbers'; }
        if (this.value < 100000 && this.value >= 10000) { return 'medium-numbers'; }
        if (this.value >= 100000) { return 'small-numbers'; }
    }

    openReport(): void {
        console.log('Widget open - type ', this.reportType);

        switch (this.reportType) {
            case 'birthday':
                this.router.navigateByUrl(`/reports/messaging?type=${this.reportType}`);
                break;
            case 'recalls':
                this.router.navigateByUrl('/reports/recalls');
                break;
            case 'missed':
                this.router.navigateByUrl('/reports/missed');
                break;
            default:
                this.router.navigateByUrl('/reports/messaging');

        }
    }
}
